<template>
  <div>

    <div class="navbar_box_fixed">
      <div class="navbar_box_width">
        <div class="navbar_box_absolute">
          <div class="page_title on_bar_center_absolute">我的群组</div>
          <div class="txtbtn_on_bar_right" @click="goToCreateGroup">新建群组</div>
          <!-- <img class="btn_on_bar_right" src="@/assets/btn_create_group.png" alt="" @click="goToCreateGroup"> -->
        </div>
      </div>
    </div>
    <div class="bar_empty_box"></div>

    <div class="group_collection">
        <div class="group_box_width" v-for="group in this.groups" :key="group.id" @click="goToGroupHome(group.id)">
          <div class="group_box_padding">
            <div class="group_box_ratio">
              <div class="group_box_absolute">
                <div class="group_coverpage_ratio">
                  <div class="group_coverpage_absolute">
                    <img class="group_coverpage" :src="group.coverpageCdnUrl1600" v-if="group.coverpage">
                    <img class="group_coverpage" src="@/assets/coverpage_group_s.png" v-if="group.coverpage === ''" alt="">
                    <div class="coverpage_empty_border"></div>
                  </div>
                </div>
                <div class="group_name">{{group.name}}</div>
                <div class="group_info">{{group.memberCount}}名成员 {{group.albumCount}}个相册</div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="clearfix"></div>
    <div class="footer"></div>
  </div>
</template>

<script>
export default {
  name: 'JoinedGroups',
  data: function () {
    return {
      userId: 0,
      groups: []
    }
  },
  async created () {
    this.userId = this.$route.params.userId
    this.groups = (await this.$faApi.getJoinedGroups(this.userId)).data
  },
  methods: {
    goToCreateGroup () {
      this.$router.push({ path: `/user/${this.userId}/group/create` })
    },
    goToGroupHome (groupId) {
      this.$router.push({ path: `/group/${groupId}` })
    }
  }
}
</script>

<style scoped lang="scss">
  .avatar {
    width: 218px;
    height: 218px;
  }
  .default_avatar {
    background-image: url('../assets/avatar.png')
  }

  .navbar_box_fixed {
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 48px;
    border-bottom: 1px solid #e0e0e0;
    background-color: white;
  }
  .navbar_box_width {
    position: relative;
    width: 100%;
    height: 48px;
  }
  .navbar_box_absolute {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
  }
  .bar_empty_box {
    position: relative;
    width: 100%;
    height: 48px;
  }
  .clearfix { clear: both; }
  .footer {    
    position: relative;
    width: 100%;
    height: 60px;
    background-color: transparent;
  }
  .page_title {
    padding: 0 16px;
    line-height: 48px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 17px;
    font-weight: 800;
    color: black;
    span {
      color: black;
      font-weight: 300;
    }
  }
  .on_bar_center_absolute {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 48px;
    right: 48px;
  }
  .btn_on_bar_right {
    position: relative;
    float: right;
    margin: 8px 8px 8px 0;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
    color: red;
    span {
      color: darkred;
      font-weight: 800;
    }
  }

  //Group
  .group_collection {
    position: relative;
    padding: 32px;
  }
  .group_box_width {
    position: relative;
    float: left;
    width: 33.33%;
  }
  .group_box_padding {
    padding: 8px;
  }
  .group_box_ratio {
    position: relative;
    width: auto;
    padding-top: 100%;
  }
  .group_box_absolute {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    cursor: pointer;
  }
  .group_coverpage_ratio {
    position: relative;
    width: 100%;
    height: 66.67%;
    border-radius: 8px;
    //background: hsla(0,0%,96%,1);
  }
  .group_coverpage_absolute {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    cursor: pointer;
  }
  .group_coverpage {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
  .coverpage_empty_border {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 8px;
    border: 1px solid hsla(0,0%,0%,.12);
  }
  .group_name {
    position: relative;
    margin: 8px -8px 0 -8px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }
  .group_info {
    position: relative;
    margin: 0;
    text-align: center;
    font-size: 12px;
    font-weight: normal;
    color: hsla(0,0%,65%,1);
  }
  @media (max-width: 359px) {
    .group_box_width { width: 50%; }
    .group_box_padding { padding: 8px; }
    .group_collection { padding: 8px; }
  }
  @media (min-width: 360px) and (max-width: 539px) {
    .group_box_width { width: 50%; }
    .group_box_padding { padding: 8px; }
    .group_collection { padding: 8px; }
  }
  @media (min-width: 540px) and (max-width: 719px) {
    .group_box_width { width: 33%; }
    .group_box_padding { padding: 8px; }
    .group_collection { padding: 8px; }
  }
  @media (min-width: 720px) and (max-width: 899px) {
    .group_box_width { width: 25%; }
    .group_box_padding { padding: 8px; }
    .group_collection { padding: 8px; }
  }
  @media (min-width: 900px) and (max-width: 1079px) {
    .group_box_width { width: 20%; }
    .group_box_padding { padding: 8px; }
    .group_collection { padding: 8px; }
  }
  @media (min-width: 1080px) and (max-width: 1259px) {
    .group_box_width { width: 16.66%; }
    .group_box_padding { padding: 8px; }
    .group_collection { padding: 8px; }
  }
  @media (min-width: 1260px) and (max-width: 1679px) {
    .group_box_width { width: 12.5%; }
    .group_box_padding { padding: 8px; }
    .group_collection { padding: 8px; }
  }
  @media (min-width: 1680px) and (max-width: 1919px) {
    .group_box_width { width: 12.5%; }
    .group_box_padding { padding: 8px; }
    .group_collection { padding: 8px; }
  }
  @media (min-width: 1920px) {
    .group_box_width { width: 10%; }
    .group_box_padding { padding: 8px; }
    .group_collection { padding: 8px; }
  }
</style>
  